import React, { Component } from 'react';
import RouteComponent from '../../Route';
import level_two_admin_config from '../../../../utils/routes/config/level_two_admin_config';

/**
 * @inheritdoc
 */
class LevelTwoAdminLayout extends Component {
    render() {
        return <RouteComponent routes={level_two_admin_config} />;
    }
}

export default LevelTwoAdminLayout;
